export interface Apps {
  title: string;
  subtitle: string;
  description: string;
  route: string;
  image?: string;
  allowedRoles: string[];
}

export const APPLICATIONS: Apps[] = [
  //ALUMNOS
   {
    title: 'Novedades',
    subtitle: 'Mantente informado',
    description: 'Consulta las últimas novedades y noticias importantes del colegio para estar al tanto de todo lo que sucede.',
    route: '/internal/estudiantes',
    image: 'https://w3miglm.blob.core.windows.net/com/wwwInternals/Images_apps/novedades.png',
    allowedRoles: ['Alumno']
  },
  {
    title: 'Calendario',
    subtitle: 'Consulta el calendario escolar',
    description: 'Consulta el calendario escolar para estar al tanto de las fechas importantes del año académico.',
    route: '/internal/estudiantes/calendario',
    image: 'https://w3miglm.blob.core.windows.net/com/wwwInternals/Images_apps/calendar.png',
    allowedRoles: ['Alumno']
  },
  {
    title: 'IXL',
    subtitle: 'Plataforma de Aprendizaje',
    description: 'IXL es una plataforma de aprendizaje en línea que ofrece ejercicios interactivos y personalizados en matemáticas, lenguaje y ciencias para estudiantes de todas las edades.',
    route: 'https://www.ixl.com/signin/glm',
    image: 'https://w3miglm.blob.core.windows.net/com/wwwInternals/Images_apps/ixl.png',
    allowedRoles: ['Alumno']
  },
  {
    title: 'Achieve3000',
    subtitle: 'Plataforma de Aprendizaje',
    description: 'Achieve3000 es una plataforma de aprendizaje en línea que ofrece contenido personalizado y adaptativo para mejorar las habilidades de lectura y comprensión de los estudiantes.',
    route: 'https://portal.achieve3000.com/index',
    image: 'https://w3miglm.blob.core.windows.net/com/wwwInternals/Images_apps/achieve3000.png',
    allowedRoles: ['Alumno']
  },
  {
    title: 'Canva',
    subtitle: 'Herramienta de Diseño Gráfico',
    description: 'Canva es una herramienta de diseño gráfico en línea que permite a los estudiantes crear presentaciones, infografías, carteles y otros materiales visuales de manera fácil y creativa.',
    route: 'https://www.canva.com/login/',
    image: 'https://w3miglm.blob.core.windows.net/com/wwwInternals/Images_apps/canva.png',
    allowedRoles: ['Alumno']
  },

  // FAMILIAS
  {
    title: 'Ayuda MiGLM',
    subtitle: 'Página de ayuda y soporte',
    description: 'Encuentra respuestas a tus preguntas y obtén soporte técnico para resolver cualquier inconveniente con la plataforma en Familias al Día.',
    route: 'https://ayuda.mi.glm.edu.co/',
    image: 'https://w3miglm.blob.core.windows.net/com/wwwInternals/Images_apps/help.png',
    allowedRoles: ['Directivo', 'JefeArea', 'Profesor', 'Admin']
  },
  {
    title: 'Familias al Día',
    subtitle: 'Página de ayuda y soporte',
    description: 'Encuentra respuestas a tus preguntas y obtén soporte técnico para resolver cualquier inconveniente con la plataforma en Familias al Día.',
    route: 'https://familiasaldia.glm.edu.co/',
    image: 'https://w3miglm.blob.core.windows.net/com/wwwInternals/Images_apps/help_fam.png',
    allowedRoles: ['Familia', 'Admin']
  },
  {
    title: 'Novedades Familias',
    subtitle: 'Mantente informado',
    description: 'Consulta las últimas novedades y noticias importantes del colegio para estar al tanto de todo lo que sucede.',
    route: '/internal/familias',
    image: 'https://w3miglm.blob.core.windows.net/com/wwwInternals/Images_apps/novedades.png',
    allowedRoles: ['Familia', 'Admin']
  },
  {
    title: 'Permisos',
    subtitle: 'Solicita permisos para sus hijos',
    description: 'Los padres pueden solicitar permisos para sus hijos, ya sea para recogerlos temprano, reportar alguna incapacidad, o cualquier otra solicitud de ausencia.',
    route: '/permiso/hijos',
    image: 'https://w3miglm.blob.core.windows.net/com/wwwInternals/Images_apps/permisos.png',
    allowedRoles: ['Familia', 'Admin']
  },
  {
    title: 'Pagos en Línea',
    subtitle: 'Realiza tus pagos de manera fácil y rápida',
    description: 'Realiza tus pagos de matrícula del colegio de forma rápida y segura.',
    route: '/internal/familias/pagos',
    image: 'https://w3miglm.blob.core.windows.net/com/wwwInternals/Images_apps/pagos.png',
    allowedRoles: ['Familia', 'Admin']
  },
  {
    title: 'Calendario',
    subtitle: 'Consulta el calendario escolar',
    description: 'Consulta el calendario escolar para estar al tanto de las fechas importantes del año académico.',
    route: '/internal/familias/calendario',
    image: 'https://w3miglm.blob.core.windows.net/com/wwwInternals/Images_apps/calendar.png',
    allowedRoles: ['Familia', 'Admin']
  },
  {
    title: 'Horarios',
    subtitle: 'Consulta los horarios de clases',
    description: 'Accede a los horarios de clases de tus hijos para estar al tanto de sus actividades académicas.',
    route: '/internal/familias/horarios',
    image: 'https://w3miglm.blob.core.windows.net/com/wwwInternals/Images_apps/horarios.png',
    allowedRoles: ['Familia', 'Admin']
  },
  {
    title: 'Lista de Utiles',
    subtitle: 'Consulta la lista de útiles escolares',
    description: 'Consulta la lista de útiles escolares para cada grado y prepara a tus hijos para el nuevo año académico.',
    route: '/internal/familias/lista-utiles',
    image: 'https://w3miglm.blob.core.windows.net/com/wwwInternals/Images_apps/utiles.png',
    allowedRoles: ['Familia', 'Admin']
  },
  {
    title: 'Schoology',
    subtitle: 'Plataforma de Aprendizaje',
    description: 'Schoology es una plataforma de gestión de aprendizaje que permite a los estudiantes acceder a cursos, tareas y recursos educativos en línea.',
    route: 'https://glm.schoology.com/login',
    image: 'https://w3miglm.blob.core.windows.net/com/wwwInternals/Images_apps/schoology.png',
    allowedRoles: ['Familia']
  },
  //PROFESORES Y COLABORADORES
  {
    title: 'Novedades',
    subtitle: 'Mantente informado',
    description: 'Consulta las últimas novedades y noticias importantes del colegio para estar al tanto de todo lo que sucede.',
    route: '/internal/staff',
    image: 'https://w3miglm.blob.core.windows.net/com/wwwInternals/Images_apps/novedades.png',
    allowedRoles: ['Directivo', 'JefeArea', 'Profesor', 'Admin', 'PersonalEmp']
  },
  {
    title: 'Calendario',
    subtitle: 'Consulta el calendario escolar',
    description: 'Consulta el calendario escolar para estar al tanto de las fechas importantes del año académico.',
    route: 'internal/colaboradores/calendario',
    image: 'https://w3miglm.blob.core.windows.net/com/wwwInternals/Images_apps/calendar.png',
    allowedRoles: ['PersonalEmp', 'Profesor', 'Directivo', 'JefeArea']
  },
  {
    title: 'Schoology',
    subtitle: 'Plataforma de Aprendizaje',
    description: 'Schoology es una plataforma de gestión de aprendizaje que permite a los estudiantes acceder a cursos, tareas y recursos educativos en línea.',
    route: 'https://glm.schoology.com/',
    image: 'https://w3miglm.blob.core.windows.net/com/wwwInternals/Images_apps/schoology.png',
    allowedRoles: ['Alumno', 'Admin', 'Profesor', 'Directivo', 'JefeArea']
  },
  {
    title: 'Jornada No Laboral',
    subtitle: 'Solicitud formulario',
    description: 'Formulario para que los profesores y/o colaboradores soliciten quedarse después de clases.',
    route: '/internal/colaboradores/nolaboral',
    image: 'https://w3miglm.blob.core.windows.net/com/wwwInternals/Images_apps/jornada_n_laboral.png',
    allowedRoles: ['Profesor', 'Admin', 'PersonalEmp', 'Directivo', 'JefeArea']
  },
  {
    title: 'Brigada',
    subtitle: 'Seguridad y Primeros Auxilios',
    description: 'Accede a la información de la Brigada Escolar del colegio para conocer los protocolos de seguridad y primeros auxilios.',
    route: 'https://brigada.glm.edu.co/',
    image: 'https://w3miglm.blob.core.windows.net/com/wwwInternals/Images_apps/brigada.png',
    allowedRoles: ['Profesor', 'PersonalEmp', 'Admin', 'Familia', 'Directivo', 'JefeArea', 'Alumno']
  },
  {
    title: 'Reuniones',
    subtitle: 'Consulta las reuniones programadas',
    description: 'Consulta las reuniones programadas con los padres de familia y otros eventos importantes del colegio.',
    route: '/reuniones',
    image: 'https://w3miglm.blob.core.windows.net/com/wwwInternals/Images_apps/reuniones.png',
    allowedRoles: ['Profesor', 'PersonalEmp', 'Admin', 'Directivo', 'JefeArea']
  },
  {
    title: 'Recursos Educativos',
    subtitle: 'Solicita materiales y recursos',
    description: 'Solicita materiales necesarios para tu clase o trabajo, de manera rápida y sencilla.',
    route: '/requisiciones/solicitar',
    image: 'https://w3miglm.blob.core.windows.net/com/wwwInternals/Images_apps/recursos.png',
    allowedRoles: ['Profesor', 'PersonalEmp', 'Admin', 'Directivo', 'JefeArea']

  },
  {
    title: 'Permisos Admin',
    subtitle: 'Solicitud de permisos laborales',
    description: 'Formulario para que los colaboradores soliciten permisos laborales de manera fácil y rápida.',
    route: '/internal/colaboradores/permisos-administrativos',
    image: 'https://w3miglm.blob.core.windows.net/com/wwwInternals/Images_apps/jornada_n_laboral.png',
    allowedRoles: ['PersonalEmp']
  },
   {
    title: 'Permisos Prof',
    subtitle: 'Solicitud de permisos laborales',
    description: 'Formulario para que los profesores soliciten permisos laborales de manera fácil y rápida.',
    route: '/internal/colaboradores/permisos-profesores',
    image: 'https://w3miglm.blob.core.windows.net/com/wwwInternals/Images_apps/jornada_n_laboral.png',
    allowedRoles: ['Profesor','Directivo', 'JefeArea']
  },
  {
    title: 'PIP',
    subtitle: 'Personal Improvement Progress',
    description: 'Aplicación diseñada para que los directores de grupo se enfoquen en el mejoramiento y progreso individual de cada niño, permitiendo un seguimiento personalizado.',
    route: '/pmp',
    image: 'https://w3miglm.blob.core.windows.net/com/wwwInternals/Images_apps/pip.png',
    allowedRoles: ['Directivo', 'Admin']
  },
  //Requisiciones Gestionar
  {
    title: 'Requisiciones',
    subtitle: 'Gestiona tus requisiciones',
    description: 'Gestiona tus requisiciones de manera eficiente y rápida.',
    route: '/requisiciones/gestionar',
    image: 'https://w3miglm.blob.core.windows.net/com/wwwInternals/Images_apps/requisiciones.png',
    allowedRoles: ['Admin', 'AdminRequisiciones']
  },
  //Permisos Gestionar
  {
    title: 'Permisos Gestionar',
    subtitle: 'Gestiona los permisos solicitados',
    description: 'Gestiona los permisos solicitados por los padres de familia de manera eficiente y rápida.',
    route: '/permiso/buscar',
    image: 'https://w3miglm.blob.core.windows.net/com/wwwInternals/Images_apps/permisos.png',
    allowedRoles: ['SecretariaDirectiva', 'Admin']
  }  
];
